import { Controller } from 'stimulus'

// Shows something meant for touch screens that the server can't tell apart
// from a desktop. It renders hidden; this decides in the browser.
//   when="ipad":   an iPad, which reports a Mac browser but has a touch screen
//                  (the "Use phone view" prompt, mobile/_prompt).
//   when="coarse": a device whose main pointer is a finger, so not a laptop
//                  with a touch screen (Phone view in the side menu).
export default class extends Controller {
  connect() {
    const touch = this.data.get('when') === 'ipad'
      ? navigator.maxTouchPoints > 1
      : window.matchMedia('(pointer: coarse)').matches
    this.element.hidden = !touch
  }
}
